require('../../../../../vendor/assets/javascripts/v2/jquery-ui-1.10.4.custom')
import 'angular-recaptcha'

dependencies = [
  "ui.sortable"
  "angular-uuid"
  "cerego.common"
  "cerego.memoryBank"
]

unless _.includes(process.env.RAILS_ENV, 'govcloud')
  dependencies.push "vcRecaptcha"

window.moduleViewApp = angular.module("cerego.moduleView", dependencies).run(['$templateCache', '$http', ($templateCache, $http) ->
  for template in [
    "association_collection"
    "cloze_container"
    "image_map"
    "vocabulary"
  ]
    $http.get Packs.iKnowRoutes.sets_v2_templates_path(template), cache: $templateCache
])

# add explicit import
req = require.context('./module-view', false, /\.js$/)
req.keys().forEach(req)

require('../../v3/modules/common/resources/tips-resource.js')
require('../../v3/modules/common/resources/v3_concept_distractors_resource.js')
require('../../v3/modules/common/directives/tip-card.ts')
require('./module-view/resources/set_changes_resource.js')

req = require.context('./module-view/controllers', false)
req.keys().forEach(req)
